jQuery(document).ready(function () {
    if (Modernizr.touchevents && Modernizr.inputtypes.date) {
        // make iOS and Android use native timepicker
        jQuery('integer-field input, input.integer-field').prop('type', 'number');
    }
});



// WEBPACK FOOTER //
// ./private/js/integer-form-fields.js